export var easeOutCubic = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
export var easeOutExpo = 'cubic-bezier(0.19, 1, 0.22, 1)';
//# sourceMappingURL=easing.js.map